import { useTranslation } from 'react-i18next';
import { Field, Form } from 'react-final-form';
import { Box, Button, Grid2 } from '@mui/material';
import { NumberInput } from '@utriper/core-ui';
import Title from 'modules/Pricing/components/Title';
import { Container, Label } from 'modules/Experience/ExperienceWizard/styles';

const AddPolicyForm = ({ onAddPolicy = () => {}, onClose = () => {} }) => {
    const { t } = useTranslation();
    const translate = (key) => t(`add_policy_form.${key}`);
    const handleSubmit = (values) => {
        onAddPolicy(values);
        onClose();
    };

    const validateForm = (values) => {
        const errors = {};

        if (values.percentage > 100) errors.percentage = translate('errors.invalid_percentage');

        return errors;
    };

    return (
        <Form
            onSubmit={handleSubmit}
            validate={validateForm}
            initialValues={{
                percentage: 0,
                days: 0,
                hours: 0,
            }}
            render={({ handleSubmit, form }) => {
                const handleChangePercentage = (event) => {
                    let percentage = 0;
                    const value = parseInt(event?.target?.value);
                    if (!Number.isInteger(value) || value < 0) percentage = 0;

                    if (value > 100) {
                        percentage = 100;
                    } else {
                        percentage = value;
                    }

                    form.change('percentage', percentage);
                };

                return (
                    <form onSubmit={handleSubmit} noValidate style={{ width: '100%', marginTop: '16px' }}>
                        <Box component="section">
                            <Title title={translate('title')} description={translate('description')} />

                            {/* Form */}
                            <Grid2 container width="100%" direction="column" justifyContent="flex-start" alignItems="flex-start" gap="8px" mt="24px">
                                {/* Time */}
                                <Container>
                                    <Label>{translate('anticipation_time')}</Label>
                                    <Grid2 container size={12} spacing={1}>
                                        <Grid2 container size={6}>
                                            <Field name="days" component={NumberInput} label={t('coreUi.timeMayus.days')} placeholder={translate('anticipation_days')} />
                                        </Grid2>
                                        <Grid2 container size={6}>
                                            <Field name="hours" component={NumberInput} label={t('coreUi.timeMayus.hours')} placeholder={translate('anticipation_hours')} />
                                        </Grid2>
                                    </Grid2>
                                </Container>

                                {/* Percentage */}
                                <Container>
                                    <Label>{translate('percentage')}</Label>
                                    <Field name="percentage" component={NumberInput} placeholder={translate('percentage_placeholder')} onChange={handleChangePercentage} />
                                </Container>
                            </Grid2>

                            <Grid2 container justifyContent="flex-end" alignItems="center" gap="16px" mt="32px" flexWrap="nowrap">
                                <Button
                                    sx={{
                                        border: '1px solid #13131340',
                                        color: '#131313',
                                        textTransform: 'none',
                                        fontWeight: 700,
                                        py: '8px',
                                    }}
                                    variant="outlined"
                                    onClick={(e) => {
                                        form.reset(e);
                                        onClose();
                                    }}
                                >
                                    {t('common.cancel')}
                                </Button>
                                <Button
                                    sx={{
                                        backgroundColor: 'var(--color-utriper-blue)',
                                        color: 'white',
                                        textTransform: 'none',
                                        fontWeight: 700,
                                        py: '8px',
                                    }}
                                    type="submit"
                                    variant="contained"
                                    onClick={handleSubmit}
                                >
                                    {translate('add_button')}
                                </Button>
                            </Grid2>
                        </Box>
                    </form>
                );
            }}
        />
    );
};

export default AddPolicyForm;
